export class ApiAuthenticationApiConstants
{
    public static readonly AUTHENTICATE: string = 'authentication/access-token';
}